import React, { useState } from "react";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import "./CaruselCards.scss";
import Pagination from "./Pagination";
import Card from "../Card";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const styles = {
  root: {
    position: "relative",
    marginBottom: "35px",
    width: "100%",
    margin: "auto",
    alignItems: "center"
  },
  slide: {
    padding: 15,
    minHeight: 100,
    color: "#fff",
    width: "100%"
  }
};

function CaruselCards() {
  const [index = 0, setIndex] = useState();

  const handleChangeIndex = index => {
    setIndex(index);
  };

  return (
    <div style={styles.root}>
      <AutoPlaySwipeableViews
        interval={3000}
        index={index}
        onChangeIndex={handleChangeIndex}
      >
        <div className="Slide">
          <Card
            image="./img/Landing/community/circulo-2-p-1.png"
            name="Emiliano Zapata"
            specialty="Defensa Criminal"
          />
          <Card
            image="./img/Landing/community/circulo-2-p-1.png"
            name="Emiliano Zapata"
            specialty="Defensa Criminal"
          />
        </div>
        <div className="Slide">
          <Card
            image="./img/Landing/community/circulo-2-p-1.png"
            name="Emiliano Zapata"
            specialty="Defensa Criminal"
          />
          <Card
            image="./img/Landing/community/circulo-2-p-1.png"
            name="Emiliano Zapata"
            specialty="Defensa Criminal"
          />
        </div>
        <div className="Slide">
          <Card
            image="./img/Landing/community/circulo-2-p-1.png"
            name="Emiliano Zapata"
            specialty="Defensa Criminal"
          />
          <Card
            image="./img/Landing/community/circulo-2-p-1.png"
            name="Emiliano Zapata"
            specialty="Defensa Criminal"
          />
        </div>
        <div className="Slide">
          <Card
            image="./img/Landing/community/circulo-2-p-1.png"
            name="Emiliano Zapata"
            specialty="Defensa Criminal"
          />
          <Card
            image="./img/Landing/community/circulo-2-p-1.png"
            name="Emiliano Zapata"
            specialty="Defensa Criminal"
          />
        </div>
        <div className="Slide">
          <Card
            image="./img/Landing/community/circulo-2-p-1.png"
            name="Emiliano Zapata"
            specialty="Defensa Criminal"
          />
          <Card
            image="./img/Landing/community/circulo-2-p-1.png"
            name="Emiliano Zapata"
            specialty="Defensa Criminal"
          />
        </div>
      </AutoPlaySwipeableViews>
      <Pagination dots={5} index={index} onChangeIndex={handleChangeIndex} />
    </div>
  );
}

export default CaruselCards;
